/**
 * Utility: Concatenate class names while filtering out falsy values.
 * Accepts any number of class name arguments and joins the truthy
 * ones with a single space. Useful for conditional Tailwind or CSS classes.
 */
export function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }